import { render, staticRenderFns } from "./BookingHistoryViewer.vue?vue&type=template&id=105ed5d4"
import script from "./BookingHistoryViewer.vue?vue&type=script&lang=ts"
export * from "./BookingHistoryViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports